<template>
  <section class="chart-container" :style="`height:${height}; width:${width};`">
    <canvas ref="chart" dir="ltr"></canvas>
  </section>
</template>

<script>
import Chart from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { getServikDisplayNames, normalizeServikNames } from '../services/filterService'
Chart.plugins.unregister(ChartDataLabels)

export default {
  props: {
    isClickable: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      validator: (prop) => prop === 'doughnut' || prop === 'line' || prop === 'bar',
      required: true,
    },
    datasets: { type: Array, required: true },
    labels: { type: Array, required: true },
    options: { type: Object, required: false },
    height: { type: String, required: false },
    width: { type: String, required: false },
    isPlugin: { type: Boolean, default: false },
    isGradient: { type: Boolean, default: false },
    endOfGradientColor: { type: String, default: 'white' },
  },
  data() {
    return {
      chart: null,
    }
  },
  mounted() {
    if (this.isGradient) this.addGradient()
    this.drawChart()
  },
  beforeDestroy() {
    clearTimeout(this.drawTimer)
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  },
  methods: {
    addGradient() {
      this.datasets.forEach((dataset, index) => {
        const ctx = this.$refs.chart.getContext('2d')
        const { max, min } = this.options.scales.yAxes[index].ticks
        let gradientStroke = ctx.createLinearGradient(0, min, 0, max)
        gradientStroke.addColorStop(0, dataset.borderColor)
        gradientStroke.addColorStop(1, this.endOfGradientColor)
        dataset.fill = true
        dataset.backgroundColor = gradientStroke
      })
    },
    drawChart() {
      this.toFixData()
      const vueThis = this
      // A language change destroys these charts before this tick. Chart.js then reads
      // .length on the missing canvas and throws on every dashboard load.
      clearTimeout(this.drawTimer)
      this.drawTimer = setTimeout(() => {
        this.drawTimer = null
        const canvas = this.$refs.chart
        if (this._isDestroyed || !canvas) return
        const callerAnimation = (this.options && this.options.animation) || {}
        let options = {
          ...this.options,
          animation: {
            ...callerAnimation,
            onComplete: function() {
              this.options.animation.onComplete = null
              vueThis.$emit('doneRender')
            },
          },
          onClick: !this.isClickable
            ? ''
            : (evt) => {
                var activePoints = this.chart.getElementsAtEvent(evt)
                if (activePoints[0]) {
                  var chartData = activePoints[0]['_chart'].config.data
                  var idx = activePoints[0]['_index']

                  var label = chartData.labels[idx]
                  var value = chartData.datasets[0].data[idx]
                  this.$emit('click', { label, value })
                }
              },
        }
        this.chart = new Chart(canvas, {
          type: this.type,
          data: { labels: this.labels, datasets: this.datasets },
          plugins: this.isPlugin ? ChartDataLabels : null,
          options,
        })

        if (!this.currentlyFilteringServik) return
        const meta = this.chart.getDatasetMeta(0)
        if (meta.type !== 'doughnut') return
        if (meta && meta.data) {
          const { labels } = meta.data[0]._chart.config.data
          const idx = labels.findIndex((label) => label === this.currentlyFilteringServik)
          if (idx > -1) meta.data[idx]._model.outerRadius += 10
        }
      }, 0)
    },
    toFixData() {
      this.datasets.forEach((dataset) => {
        dataset.data = dataset.data.map((dataItem) => {
          if (typeof dataItem !== 'number') return dataItem
          return dataItem.toFixed(1)
        })
      })
    },
  },
  computed: {
    currentlyFilteringServik() {
      const selected = normalizeServikNames(this.$store.getters.filterSelected?.servikName)
      if (selected.length !== 1) return null
      const [name] = getServikDisplayNames(
        selected,
        this.$store.getters.filterOptions?.servikName || [],
      )
      return name || null
    },
  },
  watch: {
    datasets() {
      if (!this.chart) return
      this.chart.data.datasets = this.datasets
      this.chart.data.labels = this.labels
      this.chart.destroy()
      this.drawChart()
    },
  },
}
</script>
